import {
    apiUrl
  } from '@/common/js/base.js';
export const wxApi = {
    //获取微信二次分享签名
    getWxConfig(obj) {
      return $ajax.get(apiUrl.wxBaseUrl + '/wechatoauthapi/api/content/wxShare/wechatParam', {
        params: obj
      }).then(function (res) {
        return Promise.resolve(res)
      })
    },
    addVisitLog(obj) {
      $ajax.get(apiUrl.wxBaseUrl + '/visitLog', {
        params: obj
      }).then(function (res) {
        return Promise.resolve(res)
      })
    }
}



// WEBPACK FOOTER //
// ./src/api/basic/wx/index.js